import { createContext, useContext, useState } from "react";

const CursosContext = createContext();

export function CursosProvider({ children }) {
  const [cursos, setCursos] = useState([]);

  return (
    <CursosContext.Provider value={{ cursos, setCursos }}>
      {children}
    </CursosContext.Provider>
  );
}

export function useCursos() {
  return useContext(CursosContext);
}
